<template>
  <div>
    <a :href="url">{{url}}</a>
    <CRow id="iframe">
      

    </CRow>
  </div>
</template>

<script>

export default {
  name: 'Embedded',
  data () {
    return {
    }
  },
  watch: {

  },
  methods: {
    
  },
  props: ['url'],
  mounted () {
      if(this.$route.query.url) {
        this.url = this.$route.query.url;
      }

      var element = document.getElementById("iframe");
      var iframe = document.createElement('iframe');
      iframe.src = this.url;
      iframe.width = '100%';
      iframe.height = '800px';

      element.appendChild(iframe);

      console.log('loaded iframe ', this.url);
  }
}
</script>

<style scoped>
iframe {
  width: 100%;
  height: 800px;
}
</style>
